import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Loader, Popup, PopupButtons, PopupContent } from '../../../../components';

interface IInfoPopupProps {
    title: string;
    onClose: () => void;
    type?: string;
    isLoading?: boolean;
}

export const InfoPopup: FC<IInfoPopupProps> = ({ type, title, onClose, isLoading, children }) => {
    return (
        <Popup show type={type || ''} headertext={title} onClosePopup={onClose}>
            <PopupContent className="d-flex flex-column my-3">
                {isLoading ? (
                    <div className="d-flex justify-content-center">
                        <Loader size="lg" show />
                    </div>
                ) : (
                    children
                )}
            </PopupContent>

            <PopupButtons className="justify-content-end">
                <Button variant="secondary" onClick={onClose}>
                    <FormattedMessage id="CLOSE" />
                </Button>
            </PopupButtons>
        </Popup>
    );
};
